// src/locales/useTranslation.ts
import translations from './translations';

export const useTranslation = () => {
  // For now, return English translations
  // In the future, this could support multiple languages based on user preference
  return translations.en;
};

export type TranslationKeys = keyof typeof translations.en;
